<script lang="ts">
export default {
  name: 'KkCheckbox',
}
</script>

<script lang="ts" setup>
export interface Props {
  modelValue: boolean
  id?: string
  label?: string
  isDisabled?: boolean
}

export interface Emits {
  (key: 'update:modelValue', value: Props['modelValue']): void
}

const props = withDefaults(defineProps<Props>(), {
  label: ''
})
const emits = defineEmits<Emits>()

const handleChange = () => {
  if (props.isDisabled) return
  emits('update:modelValue', !props.modelValue)
}
</script>

<template>
  <span class="checkbox">
    <input
      :id="id"
      :checked="modelValue"
      type="checkbox"
      class="checkbox__input"
      :disabled="isDisabled"
      @change="handleChange"
    >
    <label class="checkbox__label" :for="id">
      {{ label }}
    </label>
  </span>
</template>

<style scoped lang="scss">
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.checkbox {
  $root: #{&};
  display: flex;
  flex-wrap: wrap;
  &__input {
    display: none;
    cursor: pointer;

    &:checked + #{$root}__label {
      &::before {
        border-color: $color-accent-form;
        background-color: $color-accent-form;
      }
    }

    &[disabled] + #{$root}__label {
      cursor: not-allowed;
      &::before {
        border-color: #E2E2E2;
        background-color: #E2E2E2;
      }
      &::after {
        border-color: #E2E2E2;
      }
    }

    &:checked[disabled] + #{$root}__label {
      &::after {
        border-color: #FFF;
      }
    }
  }
  &__label {
    display: inline-block;
    position: relative;
    padding-left: 24px;
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
    transition: .2s;
    &::before {
      position: absolute;
      top: 50%;
      left: 0%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border: 2px solid $color-base-g;
      border-radius: 3px;
      background-color: #FFF;
      content: "";
      transition: .2s;
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 4px;
      transform: translateY(-50%) rotate(-45deg);
      width: 8px;
      height: 4px;
      border-left: 2px solid #FFF;
      border-bottom: 2px solid #FFF;
      content: "";
    }
  }
}

</style>
